import { PayloadAction, createSelector, createSlice } from '@reduxjs/toolkit'

// eslint-disable-next-line import/no-cycle
import { RootState } from './types'

interface PageState {
  subtitle?: string
  title: string
}

const initialState: PageState = {
  title: '',
}

const slice = createSlice({
  name: 'page',
  initialState,
  reducers: {
    setPageSubtitle(state, action: PayloadAction<string>) {
      state.subtitle = action.payload
    },
    setPageTitle(state, action: PayloadAction<string>) {
      state.title = action.payload
    },
    setPageState(state, action: PayloadAction<PageState>) {
      state.title = action.payload.title
      state.subtitle = action.payload.subtitle
    },
  },
})

// Actions
export const { setPageState, setPageSubtitle, setPageTitle } = slice.actions

// Selectors
const selectRoot = (state: RootState) => state.page

export const selectPageTitle = createSelector(selectRoot, ({ title }) => title)

export const selectPageSubtitle = createSelector(selectRoot, ({ subtitle }) => subtitle)

// Reduce
export default slice.reducer
